import { render, staticRenderFns } from "./TipDetails.vue?vue&type=template&id=63221733&"
import script from "./TipDetails.vue?vue&type=script&lang=js&"
export * from "./TipDetails.vue?vue&type=script&lang=js&"
import style0 from "./TipDetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports